export const EXAM_STEPS_ADVANCED_FILTERS_STORAGE_KEY = "exam_steps_advanced_filters";
